/**
 * Lullaby Constants
 * Collection of soothing lullabies for baby sleep
 */

export interface Lullaby {
  id: string;
  name: string;
  artist: string;
  duration: string; // Display format: "3:24"
  url: string; // Audio file URL - to be updated later
}

// Default lullabies - URLs will be added later by user
export const LULLABIES: Lullaby[] = [
  {
    id: "slow-mozart",
    name: "Slow Mozart",
    artist: "Mozart",
    duration: "30:00",
    url: "https://www.dropbox.com/scl/fi/1rcvuknhltvev3f0ear45/slow_mozart_small.mp3?rlkey=nak4qatn4o7caqj17bt3tz8og&st=9vl2psmw&dl=1", // Placeholder
  },
  {
    id: "nature1",
    name: "Nature Piano",
    artist: "Nature",
    duration: "30:00",
    url: "https://www.dropbox.com/scl/fi/vk0h8pg9nq1k1aeqbvown/nature1_small.mp3?rlkey=isqxxfyv0n4j4ns1o19xs5fjq&st=kvluek60&dl=1", // Placeholder
  },
  {
    id: "relaxing-waterfall",
    name: "Relaxing Waterfall",
    artist: "Nature",
    duration: "30:00",
    url: "https://www.dropbox.com/scl/fi/wqf3d4g5ad222wj0dwyid/waterfall_small.mp3?rlkey=ufj4wntcglx3dfmtscl7fk63a&st=fmjomx1o&dl=1", // Placeholder
  },
  {
    id: "white-noise",
    name: "White Noise 1",
    artist: "Nature",
    duration: "30:00",
    url: "https://www.dropbox.com/scl/fi/6h63wfw6mi1cmiuzxikr9/whitenoise.mp3?rlkey=456k0q19kbc0ivxwhtcdtx90l&st=2h25gvkk&dl=1", // Placeholder
  },
  {
    id: "white-noise2",
    name: "White Noise 2",
    artist: "Nature",
    duration: "30:00",
    url: "https://www.dropbox.com/scl/fi/c598r3m4btqs5qoxar0d2/whitenoise2.mp3?rlkey=bqlqyrc7y9tor44mck7p4flsi&st=o89qc61y&dl=1", // Placeholder
  },
];

// Fade duration in milliseconds (smooth fade to avoid waking baby)
export const LULLABY_FADE_DURATION_MS = 2000;
